import { render, staticRenderFns } from "./UploadClaimDocuments.vue?vue&type=template&id=9d4a7788&scoped=true&"
import script from "./UploadClaimDocuments.vue?vue&type=script&lang=js&"
export * from "./UploadClaimDocuments.vue?vue&type=script&lang=js&"
import style0 from "./UploadClaimDocuments.vue?vue&type=style&index=0&id=9d4a7788&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d4a7788",
  null
  
)

export default component.exports